import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";
import aa from "search-insights";

import * as AlgoliaTrackingService from "@/services/algolia/algoliaTracking.service";
import * as ConsentService from "@/services/consent/consent.service";
import FeatureTogglesService from "@/services/featureToggle/featureToggles.service";

import EventDataLayer, { SubscriberCallback } from "../../queue/EventDataLayer";
import { AlgoliaAnalyticsMinimumDataset } from "./AlgoliaAnalyticsMinimumDataset";
import { getAlgoliaAnalyticsAddToCartImpression } from "./mappers/AlgoliaAnalyticsAddToCartImpression";
import { getAlgoliaAnalyticsContentListmpression } from "./mappers/AlgoliaAnalyticsContentListmpression";
import { getAlgoliaAnalyticsProductClickImpression } from "./mappers/AlgoliaAnalyticsProductClickImpression";
import { getAlgoliaAnalyticsProductListmpression } from "./mappers/AlgoliaAnalyticsProductListmpression";
import { getAlgoliaAnalyticsPurchaseImpression } from "./mappers/AlgoliaAnalyticsPurchaseImpression";
import { getAlgoliaAnalyticsSearchFilterImpression } from "./mappers/AlgoliaAnalyticsSearchFilterImpression";

let enabled = false;

const AlgoliaConsent = async () => {
    enabled = await ConsentService.isFunctionalCookiesEnabled();

    await AlgoliaTrackingService.init();

    return;
};

const AlgoliaSubscriber = (
    eventDataLayer: EventDataLayer,
    withHistory = false
) => {
    eventDataLayer.subscribe("algolia_analytics", subscribe, withHistory);
};

const subscribe: SubscriberCallback = async (
    event: string,
    data: AnalyticsEvent
): Promise<void> => {
    if (!enabled) return;

    let aaData: Array<AlgoliaAnalyticsMinimumDataset> = [];

    switch (event) {
        case "product-click":
            if (data.payload.eventData.list) {
                aaData = getAlgoliaAnalyticsProductClickImpression(data);
            }
            break;
        case "list-impression":
            if (data.payload.eventData.name === "products") {
                aaData = getAlgoliaAnalyticsProductListmpression(data);
            }
            if (data.payload.eventData.name === "contentpages") {
                aaData = getAlgoliaAnalyticsContentListmpression(data);
            }
            break;
        case "search-filter-impression":
            aaData = getAlgoliaAnalyticsSearchFilterImpression(data);
            break;
        case "add-to-cart":
            aaData = getAlgoliaAnalyticsAddToCartImpression(data);
            break;
        case "tool-laststep":
            if (data.payload.eventData.name === "checkout") {
                aaData = getAlgoliaAnalyticsPurchaseImpression(data);
            }
            break;
        default:
            if (
                FeatureTogglesService.isEnabled(
                    FeatureToggleKey.DEBUG_ANALYTICS_LOGGING
                )
            ) {
                console.info("hubo:algolia-analytics - untracked event", event);
            }
    }

    if (aaData.length > 0) {
        aaData.forEach(({ eventName, payload }) => aa(eventName, payload));

        if (
            FeatureTogglesService.isEnabled(
                FeatureToggleKey.DEBUG_ANALYTICS_LOGGING
            )
        ) {
            console.groupCollapsed(`hubo:algolia-analytics - event`);
            console.log(aaData);
            console.groupEnd();
        }
    }
};

export { AlgoliaConsent, AlgoliaSubscriber };
